'use client'

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export const GA_ID = 'G-WKDS0V1DHR';

/**
 * Tracks SPA page views on route changes.
 * Render once in the root layout.
 */
export function Analytics() {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: pathname,
        page_title: document.title,
      });
    }
  }, [pathname]);

  return null;
}

/**
 * Fire a custom GA4 event from anywhere.
 * @param {string} eventName - GA4 event name (e.g. 'toggle_dark_mode')
 * @param {Object} params - Event parameters
 */
export function trackEvent(eventName, params = {}) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
}
